







































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { State, Action, Getter, Mutation } from 'vuex-class'

import _get from 'lodash/get'
import _intersection from 'lodash/intersection'
import _map from 'lodash/map'
import _toLower from 'lodash/toLower'

import ActiveOfferBar from '@/components/ActiveOfferBar.vue'
import NavBar from '@/components/NavBar.vue'

import { Auth0UserProfile, Offer, Seller, USER_ROLE_TYPE } from '@/types'
import { AuthState } from '@/store/auth/types'
import { NonAuthRoutes } from './settings'

const namespace: string = 'auth'

@Component({
  components: {
    ActiveOfferBar,
    NavBar,
  },
})
export default class App extends Vue {
  @State('auth') private authState: AuthState | undefined

  @Action('login', { namespace }) private login: any
  @Action('logout', { namespace }) private actionLogout: any
  @Action('getUserInfoByAuth0Id', { namespace: 'auth' }) private getUserInfoByAuth0Id: any
  @Action('getOffer', { namespace: 'offerCarts' }) private getOffer: any

  @Getter('getLoggedIn', { namespace }) private loggedIn: boolean | undefined
  @Getter('getAuth0UserProfile', { namespace }) private userAuth0Profile:
    | Auth0UserProfile
    | undefined
  @Getter('getUserInfo', { namespace }) private userInfo: any
  @Getter('getActiveOffer', { namespace: 'offerCarts' }) private activeOffer: Offer | undefined
  @Getter('getActiveSeller', { namespace: 'sellers' }) private activeSeller: Seller | undefined
  @Getter('getRequestUploadInventoryList', { namespace: 'offerCarts' })
  private requestUploadInventoryList: boolean | undefined

  @Mutation('setUserInfo', { namespace: 'auth' }) private setUserInfo: any

  private menuVisible: boolean = false
  private loading: boolean = false
  private snackText: string = 'Uploading Inventory List'
  private showSnackbar: boolean = false
  private progress: number = 0
  private progressBuffer: number = 100
  private windowWidth: number = window.innerWidth

  @Watch('$route')
  private routeChanged(to, from) {
    const path = _get(to, 'path')
    if (NonAuthRoutes.indexOf(path) >= 0) return
    if (!this.loggedIn) {
      this.login()
    } else if (!this.userInfo) {
      this.handleGetUserInfoByAuth0Id()
    }
  }

  @Watch('requestUploadInventoryList')
  private requestUploadInventoryListChanged(newVal: boolean, oldVal: boolean) {
    if (newVal && !oldVal) {
      this.progress = 0
      this.showSnackbar = true
    }
  }

  get visibleRouter() {
    if (this.$route.name === 'Callback' || this.$route.name === 'ReviewOffer') return true
    if (this.$route.name === 'Sellers' && this.isSellerRole) return false
    return this.loggedIn
  }

  get isSellerRole() {
    const userRole = _toLower(_get(this.userInfo, ['role', 'name']))
    return userRole === 'seller'
  }

  get isCheckInRole() {
    const userRoles = _get(this.userAuth0Profile, ['roles']) || []
    return (
      _intersection(
        _map(userRoles, r => _toLower(r)),
        [USER_ROLE_TYPE.CHECK_IN, USER_ROLE_TYPE.ADMIN, USER_ROLE_TYPE.SUPER_ADMIN]
      ).length > 0
    )
  }

  private created(): void {}

  private mounted(): void {
    this.setUserInfo(null)
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize)
    })

    this.$socket.client.on('InventoryList-Uploaded', data => {
      if (data === 'Failed') {
        Vue.$toast.error('Upload Inventory List failed.')
        this.showSnackbar = false
      } else {
        this.progress = 100
        setTimeout(() => {
          this.showSnackbar = false
        }, 500)
      }
    })
    this.$socket.client.on('InventoryList-Processing', data => {
      this.progress = parseInt(data, 10)
    })
  }

  private destroyed(): void {
    window.removeEventListener('resize', this.handleWindowResize)
  }

  private handleWindowResize() {
    this.windowWidth = window.innerWidth
  }

  private toggleMenu() {
    this.menuVisible = !this.menuVisible
  }

  private handleClickNavItem(routerName: string) {
    this.menuVisible = !this.menuVisible
    switch (routerName) {
      case 'logout':
        this.actionLogout()
          .then(() => {})
          .catch(err => {})
          .finally(() => {})
        break
      default:
        if (this.$route.name !== routerName) {
          this.$router.push({ name: routerName })
        }
        break
    }
  }

  private handleGetUserInfoByAuth0Id(): void {
    this.loading = true
    this.getUserInfoByAuth0Id(_get(this.userAuth0Profile, ['auth0Id']))
      .then(res => {})
      .catch(err => {})
      .finally(() => {
        this.loading = false
      })
  }
}
